export const WORKSTATIONS_TAB = 0
export const OPERATORS_TAB = 1

export const NUMBER_RANKING_ITEMS = 10

export const SKILL_MATRIX_SOURCE = 'standard'
export const SKILL_MATRIX_ACTIONS_SOURCE = 'SkillMatrix'

export const MANUAL_CHANGE = 0
export const AUDIT_CHANGE = 1

export const POSITIVE_EVALUATION_REASONS = 0
export const NEGATIVE_EVALUATION_REASONS = 1
export const ALL_EVALUATION_REASONS = 2

export const CERTIFICATION_STATUS = Object.freeze({
  ACTIVE: 0,
  ABOUT_TO_EXPIRE: 1,
  EXPIRED: 2,
  REVOKED: 3,
})

export const CERTIFICATION_STATUS_BADGES = Object.freeze({
  [CERTIFICATION_STATUS.EXPIRED]: { 
    backgroundColor: 'tw-bg-auxiliary-error-95',
    template: 'danger',
    text: 'standard_viewer.messages.certification_expired',
  },
  [CERTIFICATION_STATUS.ABOUT_TO_EXPIRE]: { 
    backgroundColor: 'tw-bg-core-neutral-cold-95', 
    template: 'default', 
    text: 'standard_viewer.messages.active',
  },
  [CERTIFICATION_STATUS.ACTIVE]: { 
    backgroundColor: 'tw-bg-core-neutral-cold-95', 
    template: 'default', 
    text: 'standard_viewer.messages.active',
  },
  [CERTIFICATION_STATUS.REVOKED]: { 
    backgroundColor: 'tw-bg-auxiliary-error-95', 
    template: 'danger', 
    text: 'settings.messages.revoked',
  },
})

export const PERSON_SELECTOR_OPTION_ROW_HEIGHT = 4.3125
